export const isValidFormat = (date) => {
  const regFomat = /^\d{2}\/\d{2}\/\d{4}$/;
  if (regFomat.test(date)) {
    const [month, day] = date.split('/');
    return Number(month) <= 12 && Number(day) <= 31;
  }
  return false;
};

export const maskedValue = (value = '') => {
  const splitedValue = value.split('/');
  const hasTwoDividers = splitedValue.length === 3;

  if (hasTwoDividers) return value;

  const preparedValue = splitedValue.join('');
  const mm = preparedValue.slice(0, 2);
  const dd = preparedValue.slice(2, 4);
  const yyyy = preparedValue.slice(4);
  const mmFormatted = mm.length === 2 ? `${mm}/` : mm;
  const ddFormatted = dd.length === 2 ? `${dd}/` : dd;

  return `${mmFormatted}${ddFormatted}${yyyy}`;
};

export const hasIgnoreClassName = (target, { ignoreClassName, stopClassName }) => {
  let node = target;

  // Traverse up the DOM tree from the current node
  while (node !== null && node !== document) {
    // Stop traversing if the stopClassName is found
    if (stopClassName && node.classList.contains(stopClassName)) {
      return false;
    }

    if (node.classList.contains(ignoreClassName)) {
      return true;
    }
    // Move up to the parent node
    node = node.parentNode;
  }

  return false;
};
